import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import './LegoBuilder.css';

interface LegoInputProps {
  value: string;
  onChange: (value: string) => void;
}

export const LegoInput: React.FC<LegoInputProps> = ({ value, onChange }) => {
  const { t } = useI18n();

  return (
    <div className='lego-input'>
      <label htmlFor='name-input'>{t.enterName}</label>
      <input
        id='name-input'
        type='text'
        value={value}
        onChange={(e) => onChange(e.target.value.toUpperCase())}
        maxLength={20}
        placeholder={t.namePlaceholder}
      />
      <p className='input-help'>{t.maxCharacters}</p>
    </div>
  );
};
